module.exports = __webpack_public_path__ + "img/ss5.a602db3b.png";